import React from 'react';

type FormFieldTitleBarProps = {
    title: string;
};

const FormFieldTitleBar = ({ title }: FormFieldTitleBarProps): JSX.Element => {
    return (
        <div className="form-field">
            <h6 className="field-title">{title}</h6>
        </div>
    );
};

export default FormFieldTitleBar;
